import { HttpClient, OpalApiResponseDocument } from '@opallabs/api'

type AssetReference = OpalApiResponseDocument<'ReadAssetReferencesV1', 200>

type updateAssetReferencePayload = Readonly<{
  data: {
    type: string
    relationships: {
      cover_asset_reference: {
        data: {
          id: string
          type: string
        }
      }
    }
  }
}>

const updateAssetReference = (
  assetId: number,
  payload: updateAssetReferencePayload
): Promise<AssetReference> => {
  const url = `/api/v1/asset_references/${assetId}`

  return HttpClient().patch(url, payload)
}

export default updateAssetReference
